<template>
  <v-main class="page-library page-library-interest">
    <AppBar title="관심 콘텐츠" extension-height="49px">
      <div class="flex-fill mx-n5">
        <v-tabs v-model="tab"
                flat center-active slider-size="3"
                class="library-tabs"
                color="text-body"
                @change="readList"
        >
          <v-tab v-for="(item, index) in tabs" :key="index" :ripple="false">
            {{ item.cdNm }}
          </v-tab>
        </v-tabs>
      </div>
    </AppBar>
    <v-container fluid>
      <v-responsive v-if="isLoading" aspect-ratio="1">
        <Loading :isLoading="isLoading" color="white" absolute />
      </v-responsive>
      <NoData v-else-if="!isLoading && items.length === 0" />
      <v-tabs-items v-else v-model="tab" touchless>
        <v-tab-item
            v-for="(tab, index) in tabs"
            :key="index"
        >
          <h4 class="d-none">{{ tab.cdNm }}</h4>
          <v-fade-transition>
            <LibraryItemList :items="items[index]"
                             :busy="isLoadingItems[index]"
                             no-data-text="찜한 콘텐츠가 없습니다."
            />
          </v-fade-transition>
        </v-tab-item>
      </v-tabs-items>
    </v-container>

  </v-main>
</template>
<script>
import store from '@/store'
import {mixinAuth} from '@/mixins'
import LibraryItemList from './LibraryItemList.vue'

export default {
  components: {
    LibraryItemList
  },
  mixins: [mixinAuth],
  data: () => ({
    isLoading: true,
    isLoadingItems: [true],
    tab: null,
    tabs: [],
    items: [],
    // filterItem: '0',
    // filterCd: 'regDt',
    // typeItem: '01',
    prevRoute: null
  }),
  created () {
    this.getCodeList('LB001')
  },
  methods: {
    async getCodeList(cdGrp) {
      this.isLoading = true
      await store.dispatch('getCodeList', this.$_payload({'cdGrp': cdGrp}))
        .then(res => {
          if (res.success) {
            this.tabs = res.data;
            this.tabs.unshift({cd: '', cdNm: '전체'})
            this.tabs.sort(function (a, b) {
              return a.cd - b.cd;
            })
            // #11281 삼성화재 일 경우, 후유이야기 -> 프랜즈이야기로 변경
            if (this.isSamsungFire) {
              this.tabs = res.data.map((item) => item.cd === '9999' ? {...item, cdNm: '프렌즈 이야기'} : item)
            }
          } else {
            this.tabs = [];
          }
        })
        .catch(error => {
          console.error(error)
          this.tabs = [];
        })
        .finally(() => {
          this.isLoading = false
          this.readList()
        })
    },
    async readList() {
      if (this.tab === null) return false
      if (this.tabs.length === 0) return false
      let cd = this.tabs[this.tab]['cd']
      this.isLoading = true
      this.$set(this.isLoadingItems, this.tab, true)
      await store.dispatch('getLibraryLikeList', this.$_payload('so', [{subject: cd}]))
        .then(res => {
          this.items[this.tab] = []
          if (res.success) {
            this.$set(this.items, this.tab, [...res.data])
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
          this.items = []
        })
        .finally(() => {
          this.isLoading = false
          this.$set(this.isLoadingItems, this.tab, false)
        })
    }
  }
}
</script>
